<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="'lg-fix-h'" :ariaLabel="$t('notificationFilter.new_document')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('notificationFilter.new_document')}}</h2>
          <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-y-auto"
        style="max-height: 50vh"
      >
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
        >
        
          <div class="lg:mb-2 flex -mx-2 flex-col lg:flex-row">
            <div class="px-2 w-full" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">

              <accessible-el-select
                prop="idCliente"
                v-model="form.idCliente"
                :options="clientes.map(x => ({ id: x.IdEmpresa, value: x.IdEmpresa, name: x.Nombre }))"
                id-prefix="maestrodocumentosnewdocumentdialog"
              >
                <template #label>
                  <base-obligatory-icon/>{{$t('app.client')}}
                </template>
              </accessible-el-select>

            </div>
            <div class="px-2 w-full">

              <accessible-el-select
                prop="idCIFEmpresa"
                v-model="form.idCIFEmpresa"
                :disabled="isSelectClientEmpty && (role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')"
                :options="companies.map(x => ({ id: x.value, value: x.value, name: x.label }))"
                id-prefix="maestrodocumentosnewdocumentdialog"
              >
                <template #label>
                  {{$t('app.company')}}
                </template>
              </accessible-el-select>

            </div>
          </div>

        <accessible-el-select
          prop="tipoDocumento"
          v-model="form.tipoDocumento"
          :options="valuesTipoDocumento.map(x => ({ id: x.id, value: x.id, name: x.value }))"
          id-prefix="maestrodocumentosnewdocumentdialog"
        >
          <template #label>
            <base-obligatory-icon/>Tipo de documento
          </template>
        </accessible-el-select>
        
        <div 
          class="px-2 mb-2 lg:mb-0 "
          :class="[isLower1024 ? '' : 'center']">
          <el-form-item prop="file" ref="fileRef">
            <Upload
                role="button"
                ref="upload"
                id="fileSelector"
                class="bg-white dark:bg-darkblue-900"
                :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                drag
                multiple
                action="#"
                :auto-upload=false
                :on-progress="handleProgress"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="this.maxFiles"
                :on-change="handleChange"
                :on-exceed="handleOnExceed"
                >
                <i class="el-icon-upload"></i>
                <p v-if="file.length" class="el-upload__text"><em>{{this.fileName}}</em></p>
                <div v-else class="el-upload__text">Suelta tus archivos aquí o <em>haz clic para cargar</em></div>
            </Upload>
          </el-form-item>
        </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button :disabled="disabledApply" mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="uploadNewDocument('ruleForm')"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJUNTOS_PRESENTACION } from '@/config/extensiones-adjuntos-presentacion'
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getClients } from '@/services/clients/getClients'
import { getAllCompanies } from '@/services/companies/getAllCompanies'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'maestro-documentos-new-document-dialog',
  components: {
    Upload,
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    valuesTipoDocumento: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        tipoDocumento: '',
        idCliente: null,
        idCIFEmpresa: null,
      },
      maxFiles: 20,
      maxSizeFile: 5242880, // Bytes (5MB)
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJUNTOS_PRESENTACION,
      file: [],
      clientes: [],
      companies: [],
      newRules: {
        idCliente: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        tipoDocumento: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        file: [
          {
            required: true,
            message: this.$i18n.t('validation.exceed_size_files') + ' ('+ this.maxMB+ ' MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file || this.file.filter(x => x.size > this.maxSizeFile).length > 0) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                if (!this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                this.doAriaLiveAndReturnCallback(this.extensionRuleMessage, callback)
              } else {
                callback()
              }
            }
          },
        ]
      }
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.loadClients()
        if (!(this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')) {
          this.getCompaniesHandler()
        }
      } else {
        this.file = []
        this.getDefaultForm() 
      }
    },
    'form.idCliente': {
      deep: true,
      handler: 'watchidClienteHandler'
    },
  },
  mounted: async function () {
  },
  computed: {
    empresaFilter () {
      return this.$store.getters['documentmaster/getMasterFilters']?.empresa?.value || null
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSelectClientEmpty: function () {
      return this.form.idCliente === null || this.form.idCliente === undefined || this.form.idCliente === ''
    },
    extensionRuleMessage: function () {
      return i18n.t('validation.not_extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return '(' + this.file.length + ') Archivos'
      }
    },
    disabledApply: function () {
      return this.file === undefined || this.file === null || this.file.length === 0
    },
    extensionTooltipMessage: function () {
      return 'Número máximo de ficheros: ' + this.maxFiles + '. Tamaño máximo por fichero: ' + this.maxMB + 'MB. ' +
      i18n.t('validation.extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    maxMB () {
      return this.maxSizeFile / 1024 / 1024
    },
  },
  methods: {
    loadClients: async function () {
      this.clientes = []
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        const dataClients = await getClients()
        if (dataClients.blnError === true) {
          this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
        }
        this.clientes = dataClients.Empresas
        console.log('preSelectClient', this.form)
        
        this.preSelectClient(this.form, 'idCliente')
      }
    },
    watchidClienteHandler: async function () {
      // this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
      this.form.idCIFEmpresa = null
      if (this.form.idCliente !== undefined && this.form.idCliente !== null && this.form.idCliente !== '') {
        this.getCompaniesHandler()
      }
    },
    getCompaniesHandler: async function () {
      this.companies = []
      const data = await getAllCompanies({ idEmpresaCert: this.form.idCliente })
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        data.CIFSEmpresa.forEach(row => {
          this.companies.push({ value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.NombreCIF })
        })
      }
    },
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.file = []
      this.getDefaultForm()
      this.$emit('toggleDialog')
    },
    getDefaultForm () {
      this.form = {
        tipoDocumento: '',
        idCliente: null,
        idCIFEmpresa: null,
      }
    },
    handleOnExceed: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + this.maxFiles + ')', 'warning')
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    uploadNewDocument: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$emit('applyDialog', this.file, this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 40%;
  border: none;
  padding: 1px;
}

</style>
